export enum OrgSharedDataTag {
  GET_APPLICATION_DEFINITION = 'get-application-definition',
  GET_ASSESSMENT_QUESTIONS = 'get-assessment-questions',
  GET_BOOKMARKS = 'get-bookmarks',
  GET_CENTER_APPLICATION_DEFINITION = 'get-center-application-definition',
  GET_COMMUNICATION_PREFERENCES = 'get-communication-preferences',
  GET_COMPANIES = 'get-companies',
  GET_COMPANY_LISTING = 'get-company-listing',
  GET_COUNTRIES = 'get-countries',
  GET_COUNTRY_STATES = 'get-country-states',
  GET_CUSTOMER_MEETINGS = 'get-customer-meetings',
  GET_CUSTOMER_OPTIMIZELY_ROLES = 'get-customer-optimizely-roles',
  GET_CUSTOMER_PROFILE = 'get-customer-profile',
  GET_CUSTOMER_PROFILE_ADB2C_OBJECT_ID = 'get-customer-profile-adb2c-object-id',
  GET_DESIGNATIONS = 'get-designations',
  GET_DONATION_LEVELS = 'get-donation-levels',
  GET_GENDERS = 'get-genders',
  GET_LANGUAGES = 'get-languages',
  GET_MEMBER_DIRECTORY_SEARCH_RESULTS = 'get-member-directory-search-results',
  GET_MEMBERSHIP_APPLICATION = 'get-membership-application',
  GET_MEMBERSHIP_HISTORY_TIMELINE = 'get-membership-history-timeline',
  GET_MEMBERSHIP_REQUIREMENTS = 'get-membership-requirements',
  GET_OPTIMIZELY_CONTENT = 'get-optimizely-content',
  GET_OPTIMIZELY_REDIRECTS = 'get-optimizely-redirects',
  GET_PHONE_TYPES = 'get-phone-types',
  GET_PREFIXES = 'get-prefixes',
  GET_PROFILE_PICTURE = 'get-profile-picture',
  GET_PUBLIC_CUSTOMER_PROFILE = 'get-public-customer-profile',
  GET_RECEIPT = 'get-receipt',
  GET_RECOMMENDED_ARTICLES_FOR_YOU = 'get-recommended-articles-for-you',
  GET_SUFFIXES = 'get-suffixes',
  GET_USER_ACCESS_FLAGS = 'get-user-access-flags',
  GET_USER_NOTIFICATIONS = 'get-user-notifications',
}
